import useApi from "@/services/useApi";
import {showToast} from '@/helpers/showToast'


const defaultState = () => ({
    loading: {
        create: false
    }
})

const invoiceModule = {
    namespaced: true,
    state: defaultState(),
    getters: {
        getIsCreateLoading: (state) => state.loading.create,
    },
    mutations: {
        SET_LOADING(state, {loadingName, value}) {
            state.loading[loadingName] = value
        }
    },
    actions: {
        async createInvoice({commit}, {payload, moshaToast}) {
            const {api, headers} = useApi();
            try {
                commit('SET_LOADING', {loadingName: 'create', value: true})
                const {data} = await api.post('/api/invoice', {...payload}, {headers})
                showToast(moshaToast, 'success', data?.description || 'Successfully')
            } catch (e) {
                showToast(moshaToast, 'error', e?.response?.data?.description || 'Something went wrong')
            } finally {
                commit('SET_LOADING', {loadingName: 'create', value: false})
                commit('closeDialog', null, {root: true})
            }
        }
    }
}

export default invoiceModule
